import { render, staticRenderFns } from "./ProjectImage.vue?vue&type=template&id=fb315a02&"
import script from "./ProjectImage.vue?vue&type=script&lang=js&"
export * from "./ProjectImage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports